<template>
  <div class="tabbar editor-nav">
    <a
      v-for="(title, key) in views"
      :key="key"
      class="editor-nav__link"
      :class="{ 'is-active': active === key }"
      @click="chooseView(key as unknown as ViewName)"
    >
      {{ title }}
    </a>
  </div>
</template>

<script setup lang="ts" generic="ViewName extends string">
interface Props {
  active?: string;
  views: Record<ViewName, string>;
}
withDefaults(defineProps<Props>(), {
  active: undefined
});

const emit = defineEmits<{
  (e: "choose", view: ViewName): void;
}>();

function chooseView(view: ViewName) {
  emit("choose", view);
}
</script>

<style lang="scss">
.tabbar {
  box-shadow: 0 0 1rem var(--color-shadow-2);
  padding: 0 3rem;
  font-size: 14px;
  z-index: 1;
  background-color: var(--color-background-deep);
}
</style>
